var lineHeights = {
    display: {
        lg: "96px",
        md: "70px",
        sm: "60px",
        xs: "50px",
    },
    heading: {
        xxxl: "39px",
        xxl: "32px",
        xl: "30px",
        lg: "25px",
        md: "22px",
        sm: "20px",
        xs: "18px",
        xxs: "16px",
    },
    label: {
        md: "20px",
        sm: "17px",
        xs: "15px",
    },
    paragraph: {
        xxxl: "39px",
        xxl: "32px",
        xl: "30px",
        lg: "25px",
        md: "20px",
        sm: "18px",
        xs: "16px",
    },
};

export { lineHeights as default };
//# sourceMappingURL=lineHeights.js.map
